export default __webpack_public_path__ + "static/media/sopimus-lightblue.de488ee0.svg";